import React from "react";
import heroImage from "../../assets/EMP_restaurant/restaurant-qsr-hero.webp"; 
import topImage from "../../assets/EMP_GroceryTrustedSection/tips-promo-banner-inpage.webp";

import EMP_Staff from "../../Components/EmployersComponents/EMP_restaurantsqr/EMP_staff";
import EMP_StickyScrollSection from "../../Components/EmployersComponents/EMP_restaurantsqr/EMP_ StickyScrollSection";
import EMP_RestaurantTrustSection from "../../Components/EmployersComponents/EMP_restaurantsqr/EMP_RestaurantTrustSection";
import EMP_RestaurantResources from "../../Components/EmployersComponents/EMP_restaurantsqr/EMP_RestaurantResources";
import  EMP_RestaurantFAQ from "../../Components/EmployersComponents/EMP_restaurantsqr/EMP_RestaurantFAQ";
import GroceryInsightsFormSection from "../../Components/EmployersComponents/EMP_grocery/GroceryInsightsFormSection";
import Footer from "../../Components/Footer";


const EMP_Restaurantqsr = () => {
  return (
    < >
    <section
      className="
        w-full
        min-h-screen
        bg-white
        flex
        flex-col
        lg:flex-row
        items-center
        justify-between
        gap-10
        px-6
        md:px-12
        lg:px-20
        lg:py-16
        overflow-hidden
        -mb-[100px]
        lg:-mb-0
      "
    >
      {/* LEFT CONTENT */}
      <div className="flex-1 max-w-[620px] text-center lg:text-left lg:ml-[30px]">
        
       <p
  className="
    mt-[70px]
    -ml-[160px]
    md:-ml-[500px]
    lg:-ml-0
    lg:mt-0
    mb-8
    uppercase
    text-[14px]
    font-[900]
    md:text-[16px]
    md:font-[900]
    lg:font-semibold
    tracking-[1.5px]
    lg:tracking-[1px]
    text-[#b34800]
  "
>
  Restaurants & QSR
</p>

       <h1
  className="
    dp-font-50
    text-[#220000]
    leading-[1]
    max-w-[530px]
    mt-0
    mb-7
    text-[38px]
    font-[100]
    -ml-[90px]
    lg:-ml-0

    sm:text-[50px]
    md:text-[50px]
    lg:text-[50px]
    lg:font-extralight
    xl:text-[58px]
  "
  style={{ fontFamily: "serif" }}
>
  A Happier Staff<br className="block lg:block md:hidden" />
  Delivers Better<br  className="block md:hidden"/>
   <span className="ml-[30px] lg:ml-0"> Customer Service</span> 
</h1>
        <p
          className="
            text-black
            mt-8
            -ml-[55px]
            lg:-ml-0
            text-[16px]
            sm:text-[18px]
            md:text-[20px]
            lg:text-[18px]
            lg:font-sans
            leading-relaxed
            max-w-[430px]
            lg:max-w-[430px]
            mx-auto
            lg:mx-0
          "
        >
          Improve employee engagement and <br className="block lg:hidden" /> retention with on-demand pay.
        </p>

        <button
  className="
    mt-8
    bg-[#2a0000]
    text-white
    px-4
    py-2
    sm:px-5
    sm:py-3
    lg:px-6
    lg:py-3
    text-[15px]
    sm:text-[16px]
    font-semibold
    hover:bg-[#4a0000]
    transition-all
    duration-300
    hover:-translate-y-1
    w-auto
    -ml-[190px]
    lg:-ml-0
  "
>
  Book a Demo
</button>
      </div>

      {/* RIGHT IMAGE */}
      <div className="flex-1 flex justify-center items-center w-full  ">
        <img
          src={heroImage}
          alt="Restaurant Illustration"
          className="
            w-[350px]
            max-w-[700px]
            lg:w-[600px]
            lg:mb-[40px]
            object-contain
            -mt-[300px]
            lg:-mt-0
            ml-[50px]
          "
        />
      </div>
    </section>

    <section
      className="
        hidden lg:block
        relative
        left-1/2
        right-1/2
        -ml-[50vw]
        -mr-[50vw]
        w-screen
        bg-[#d0e3f1]
        overflow-visible
        py-4
        lg:h-[100px]
      "
    >
      <div
        className="
          w-full
          lg:w-full
          flex
          flex-col
          lg:flex-row
          items-center
          justify-between
          gap-10
          px-6
          lg:px-20
        "
      >
        {/* LEFT PHONE IMAGE */}
        <div
          className="
            lg:w-[35%]
            relative
            flex
            justify-center
            overflow-visible
            lg:mb-[47px]
          "
        >
          <img
            src={topImage}
            alt=""
            className="
              w-full
              max-w-[250px]
              object-contain
              relative
              lg:-mt-[90px]
              z-20
            "
          />
        </div>
    
        {/* CENTER CONTENT */}
        <div className="lg:w-[45%] lg:-mt-[130px]">
    
          <span
            className="
              inline-block
              bg-[#d45500]
              text-white
              text-[14px]
              font-bold
              px-2.5
              py-1
              rounded-full
              -ml-[100px]
            "
          >
            New
          </span>
    
          <h2
            className="
              text-[#240000]
              text-[32px]
              lg:text-[20px]
              leading-[1]
              font-serif
              lg:-ml-[100px]
              lg:mt-[15px]
            "
            style={{
            //   fontFamily: "'Cormorant Garamond', serif",
            }}
          >
            DailyPay Tips
          </h2>
    
          <p
            className="
              mt-1
              text-[#120000]
              text-[18px]
              lg:text-[16px]
              leading-[1.5]
              max-w-[650px]
              lg:-ml-[100px]
            "
          >
            Introducing real-time digital tips access powered by
            DailyPay.
          </p>
        </div>
    
        {/* RIGHT BUTTON */}
        <div className="lg:w-[20%] flex justify-center lg:justify-start -mt-[80px]">
          <button
            className="
              border-2
              border-[#16244d]
              text-[#16244d]
              hover:bg-[#16244d]
              hover:text-white
              px-4
              py-2
              rounded-full
              text-[18px]
              font-semibold
              transition-all
              duration-300
            "
          >
            Learn More
          </button>
        </div>
      </div>
    </section>

    <section className="w-full bg-white py-12 sm:py-16 md:py-20 lg:py-28 px-4 sm:px-6 md:px-10 lg:px-16">

  <div
    className="
      max-w-[1800px]
      mx-auto
      bg-[#ececec]
      rounded-[20px]
      md:rounded-[20px]
      lg:rounded-[36px]
      px-6
      sm:px-10
      md:px-14
      lg:px-20
      py-10
      sm:py-14
      md:py-16
      lg:py-24
      flex
      flex-col
      lg:flex-row
      items-start
      justify-between
      gap-12
      lg:gap-24
    "
  >

    {/* LEFT CONTENT */}
    <div className="flex-1 w-full max-w-[620px] lg:ml-[60px] md:-ml-[30px] ">

      {/* TITLE */}
      <div className="flex items-start gap-4">

        {/* ORANGE BAR */}
        <div className="flex items-start">

  {/* ORANGE LINE */}
  <div
    className="
      w-[6px]
      sm:w-[7px]
      md:w-[8px]
      h-[58px]
      sm:h-[64px]
      md:h-[72px]
      lg:h-[60px]
      bg-[#ff5100]
      mt-[6px]
      mr-[2px]
      flex-shrink-0
      md:-mt-[20px]
    "
  ></div>

  {/* HEADING */}
  <h2
    className="
      text-[#220000]
      font-extralight
      leading-[0.95]
      mt-0
      lg:mt-4
      mb-0
      text-[34px]
      sm:text-[52px]
      md:text-[42px]
      md:font-extralight
      lg:text-[46px]
      lg:font-extralight
    "
  >
    Overcome Challenges
  </h2>

</div>
      </div>

      {/* SUBTEXT */}
      <p
        className="
          mt-8
          md:mt-2
          lg:mt-6
          text-black
          font-extrabold
          leading-relaxed
          text-[14px]
          sm:text-[22px]
          md:text-[18px]
          lg:text-[18px]
          lg:font-sans
          max-w-[550px]
          lg:w-[400px]
          md:max-w-[450px]
        "
      >
        Quick-service restaurants (QSRs) face numerous hurdles
        as they welcome customers back.
      </p>

    </div>

    {/* RIGHT CONTENT */}
    <div className="flex-1 w-full max-w-[760px]">

  <p
    className="
      mb-0
      -mt-[10px]
      lg:-mt-0
      max-w-[500px]
      text-black
      font-1100
      lg:font-normal
      leading-[32px]
      text-[21px]
      sm:text-[19px]
      md:text-[20px]
      lg:text-[20px]
    "
  >
    The ongoing labor shortage, supply chain issues, and
    inflation are all complicating matters as restaurants
    look to recoup their losses throughout the pandemic.
    
    To address these various challenges, restaurant owners
    must prioritize staff{" "}

    <span className="text-[#ff5100] font-semibold">
      retention
    </span>{" "}

    and satisfaction to improve customer service.
  </p>

</div>
  </div>

</section>

<EMP_Staff />
<EMP_StickyScrollSection />
<EMP_RestaurantTrustSection />
<EMP_RestaurantResources />
<EMP_RestaurantFAQ />
<GroceryInsightsFormSection />
<Footer />

    </>
  );
};

export default EMP_Restaurantqsr;